<!-- file-dropzone-with-list component -->
<div class="file-dropzone-with-list">
  <div class="custom-dropzone" kendoUploadDropZone="myZone" (click)="this.clickDropzone()" (keydown)="this.clickDropzone()">
    <div class="default-container" *ngIf="!this.showFilesInDropzone || this.fileList.length === 0">
      <img
        src="../../../assets/images/now-file-upload.png"
        alt="file upload zone image"
        height="50"
        width="50"
      />
      <h4>Drop files within this space or click the upload files</h4>
    </div>
    <div class="file-list" *ngIf="this.showFilesInDropzone && this.fileList.length > 0">
      <div class="file" *ngFor="let file of this.fileList">
        <svg
          width="20"
          height="20"
          (click)="this.deleteDocument(file, $event)"
          (keydown.enter)="this.deleteDocument(file, $event)"
          (keydown.Space)="this.deleteDocument(file, $event)"
          tabindex="0"
        >
          <circle
            cx="10"
            cy="10"
            r="9"
            stroke="black"
            stroke-width="1"
            fill="white"
          />
          <text x="10" y="14" font-size="12" text-anchor="middle">X</text>
        </svg>
        <img alt="{{ this.file.name }} image" src="{{ this.file.imgPath }}" />
        <span>{{ this.file.name }}</span>
      </div>
    </div>
  </div>
  <div [formGroup]="parentForm">
    <kendo-upload
      #select
      zoneId="myZone"
      [autoUpload]="false"
      [saveUrl]="uploadSaveUrl"
      [removeUrl]="uploadRemoveUrl"
      [multiple]="multipleFile"
      [restrictions]="fileRestrictions"
      (select)="selectEventHandler($event)"
      (complete)="uploadCleanUp()"
      style="display: none;"
    >
    </kendo-upload>
  </div>
</div>
